import { Box, Paper, TextField, ThemeProvider } from "@mui/material";
import LoadingButton from "components/button/LoadingButton";
import { useFormik } from "formik";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionLogin } from "redux/authentication";
import { AuthApi } from "service/api/auth.api";
import muiTheme from "theme/muiTheme";
import { getTextFieldProps } from "ultis/form";

import OTP from "./components/OTP";

const Login = () => {
  const [loadingLogin, setLoadingLogin] = useState(false);
  const dispatch = useDispatch();
  const [otpResponse, setOtpResponse] = useState(null);
  const loadingConfirmOTP = useSelector(
    (state) => state.auth.loadingConfirmOTP
  );

  const handleLogin = async ({ username, password }) => {
    setLoadingLogin(true);
    try {
      const { data: responseData } = await AuthApi.loginV2({
        username,
        password,
      });

      if (responseData.data?.loginType === 1) {
        dispatch(actionLogin(responseData.data));
      }
      if (responseData.data?.loginType === 2) {
        setOtpResponse(responseData);
      }
    } catch (error) {
      console.log("error", error);
    }
    setLoadingLogin(false);
  };

  const form = useFormik({
    initialValues: {
      username: "",
      password: "",
    },
    onSubmit: handleLogin,
  });

  return (
    <ThemeProvider theme={muiTheme}>
      <Box component="main" sx={{ display: "flex", justifyContent: "center" }}>
        {!otpResponse && (
          <Paper
            sx={{
              width: 430,
              p: 3,
              mt: 10,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: 2,
            }}>
            <img
              src={`${process.env.REACT_APP_PATH}/vnpost-logo.png`}
              alt="logo"
              style={{ width: 300 }}
            />
            <form onSubmit={form.handleSubmit} style={{ width: "100%" }}>
              <Box sx={{ display: "grid", gap: 1 }}>
                <TextField
                  {...getTextFieldProps(form, "username")}
                  label="Username"
                  required
                  variant="standard"
                />
                <TextField
                  {...getTextFieldProps(form, "password")}
                  label="Password"
                  type="password"
                  required
                  variant="standard"
                />
                <LoadingButton
                  type="submit"
                  fullWidth
                  variant="contained"
                  loading={loadingLogin || loadingConfirmOTP}
                  sx={{ mt: 1 }}>
                  Đăng nhập
                </LoadingButton>
              </Box>
            </form>
          </Paper>
        )}
        {otpResponse && (
          <Paper
            sx={{
              p: 2,
              mt: 10,
            }}>
            <OTP
              expire={otpResponse.data?.expire}
              jwtToken={otpResponse.data?.jwtToken}
              message={otpResponse.message}
            />
          </Paper>
        )}
      </Box>
    </ThemeProvider>
  );
};

export default Login;
